<mat-option #selectAllOption class="bottom-divider" (click)="selectedChange.emit(selectAllOption.selected)">{{ text }}</mat-option>
